import * as v from 'valibot';

export const LearningJourneyContextSchema = v.object({
  external_enrollment_id: v.string(),
  external_workflow_id: v.string(),
  external_version_id: v.string(),
  name: v.string(),
});

export interface LearningJourneyContext {
  external_enrollment_id: string;
  external_workflow_id: string;
  external_version_id: string;
  name: string;
}

export interface LearningJourneyCachedContextEntry {
  ljEnrollmentId: string;
  entryCreatedAt: number;
}

export const LEARNING_JOURNEY_CACHED_CONTEXT_KEY = 'lj-context';
export const LEARNING_JOURNEY_CACHED_CONTEXT_VALUE_KEY = 'ljEnrollmentId';

export const LEARNING_JOURNEY_ENROLLMENT_TYPE = 'journey-enrollment' as const;
export const COURSE_ENROLLMENT_TYPE = 'course-enrollment' as const;

export type EnrollmentType = typeof LEARNING_JOURNEY_ENROLLMENT_TYPE | typeof COURSE_ENROLLMENT_TYPE;
